import { Link, useLocation, useNavigate } from "react-router-dom";
import TopbarInner from "../../components/topbar/TopbarInner";
import "./legal-pages.css";

const LEGAL_LINKS = [
  { to: "/legal/mentions-legales", label: "Mentions légales" },
  { to: "/legal/politique-confidentialite", label: "Confidentialité" },
  { to: "/legal/cgv", label: "Conditions de vente" },
  { to: "/legal/remboursement", label: "Annulation et remboursement" },
];

export function LegalSection({ number, title, children, highlight = false }) {
  return (
    <section className={`legal-section ${highlight ? "legal-section--highlight" : ""}`}>
      <div className="legal-section__heading">
        {number && <span className="legal-section__number" aria-hidden="true">{number}</span>}
        <h2 className="legal-section__title">{title}</h2>
      </div>
      <div className="legal-section__body">{children}</div>
    </section>
  );
}

export function LegalCallout({ title, children }) {
  return (
    <aside className="legal-callout">
      <strong className="legal-callout__title">{title}</strong>
      <div className="legal-callout__body">{children}</div>
    </aside>
  );
}

export default function LegalPageLayout({ title, topbarTitle = title, eyebrow = "Informations légales", lead, updatedAt, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const fromProfile = location.state?.legalOrigin === "profile";
  const legalNavigationState = fromProfile ? { legalOrigin: "profile", from: "/profil" } : null;

const handleBack = () => {
  if (fromProfile) {
    navigate("/profil");
    return;
  }

  navigate("/");
};

  return (
<div className={`legal-shell ${fromProfile ? "legal-shell--profile" : "legal-shell--public"}`}>
<TopbarInner
  title={topbarTitle}
  titleColor="#36495B"
  onBack={handleBack}
  onLogoClick={() => navigate("/")}
  showThemeDropdown={false}
/>
      <main className="legal-page">
        <header className="legal-hero">
          <p className="legal-hero__eyebrow">{eyebrow}</p>
          <h1 className="legal-hero__title">{title}</h1>
          <p className="legal-hero__lead">{lead}</p>
          {updatedAt && <p className="legal-hero__updated">Dernière mise à jour : {updatedAt}</p>}
        </header>

        <article className="legal-content">{children}</article>

        <nav className="legal-navigation" aria-label="Autres pages légales">
          {LEGAL_LINKS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              state={legalNavigationState}
              className={`legal-navigation__link ${location.pathname === item.to ? "is-current" : ""}`}
              aria-current={location.pathname === item.to ? "page" : undefined}
            >
              {item.label}
            </Link>
          ))}
        </nav>

<div className="legal-footer">
  <button
    type="button"
    className="legal-footer__button"
    onClick={handleBack}
  >
    {fromProfile ? "Retour au profil" : "Retour à l’accueil"}
  </button>
</div>
      </main>
    </div>
  );
}
